<button
  [attr.type]="type"
  [attr.aria-label]="ariaLabel"
  class="k-btn"
  [disabled]="disabled"
  [class]="styleClass"
  [ngClass]="buttonClass()"
  (focus)="onFocus.emit($event)"
  (blur)="onBlur.emit($event)"
>
  @if (loading) {
  <span class="k-spinner" aria-hidden="true"></span>
  } @else {
  <ng-content select="[k-icon-start]"></ng-content>
  } @if (label) {
  <span
    class="k-label"
    [ngClass]="size === 'small' || size === 'compact' ? 'button-text-14' : 'button-text-16'"
    >{{ label }}</span
  >
  }
  <ng-content select="[k-icon-end]"></ng-content>
</button>
